import { MotionReveal } from "../components/MotionReveal";
import { Link } from "react-router-dom";

const models = [
  {
    title: "AIOps Maturity Assessment",
    meta: "Duration: 2–4 weeks",
    desc: "Deliverable: Maturity scorecard, roadmap, quick wins. Ideal for: starting the journey.",
  },
  {
    title: "CoE Setup & Governance",
    meta: "Duration: 3–6 months",
    desc: "Deliverable: Operating model, governance framework, team structure. Ideal for: building internal capability.",
  },
  {
    title: "Platform Engineering",
    meta: "Duration: Varies",
    desc: "Deliverable: Architecture design, tool implementation, integration. Ideal for: technology deployment.",
  },
  {
    title: "Managed Observability",
    meta: "Duration: Ongoing",
    desc: "Deliverable: 24x7 monitoring, proactive management, continuous optimization. Ideal for: outsourced operations.",
  },
  {
    title: "Automation & Runbooks",
    meta: "Duration: 1–3 months per use case",
    desc: "Deliverable: Automated remediation, self-healing capabilities. Ideal for: operational efficiency.",
  },
  {
    title: "Executive Dashboards & QBRs",
    meta: "Duration: Ongoing",
    desc: "Deliverable: Custom dashboards, quarterly business reviews, insights. Ideal for: leadership visibility.",
  },
];

export default function EngagementModelsPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-6 sm:pt-10">
        <MotionReveal>
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[var(--text-secondary)]">
              From assessment to managed services
            </div>
            <h1 className="mt-6 font-[var(--font-display)] text-4xl sm:text-5xl tracking-tight text-white">Engagement Models</h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base text-[var(--text-secondary)]">
              Choose the right motion for your organization — from rapid assessment to fully managed observability.
            </p>
          </div>
        </MotionReveal>
      </div>

      <section className="mt-10 sm:mt-14">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {models.map((m, idx) => (
            <MotionReveal key={m.title} delay={Math.min(0.35, idx * 0.05)}>
              <div className="glass-panel hover-lift rounded-3xl p-6">
                <div className="font-[var(--font-display)] text-xl tracking-tight text-white">{m.title}</div>
                <div className="mt-3 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-[var(--text-secondary)] inline-flex">
                  {m.meta}
                </div>
                <div className="mt-4 text-sm leading-relaxed text-[var(--text-secondary)]">{m.desc}</div>
                <Link to="/contact" className="mt-6 inline-flex text-sm font-medium text-[var(--accent-primary)] hover:brightness-110">
                  Discuss this engagement
                </Link>
              </div>
            </MotionReveal>
          ))}
        </div>
      </section>

      <div className="h-12" />
    </div>
  );
}
